import React, { useState } from "react";
import PropTypes from "prop-types";
import { convertToHumanReadable, formatDate } from "../../utils";
import { navigate } from "gatsby";
import classNames from "classnames";

import {
  container,
  image_container,
  text_container,
  tag_is_closed,
  tag_is_open,
  extended_buttons_open,
  extended_buttons_closed,
  header,
  footer,
  type_button,
  tag_button,
  brand_button,
  location_label
} from "./styles.module.scss";
import SVG from "../svg/component";

const Card = (props) => {
  const {
    src,
    title,
    path,
    publishDate,
    topics = [],
    tags = [],
    types = [],
    handleSelect,
    location = "Redi-Rock"
  } = props;

  const [isOpen, setIsOpen] = useState(false);

  const typesWithClass = types.map((type) => {
    return { ...type, classes: type_button, section: "types" };
  });
  const tagsWithClass = tags.map((tag) => {
    return { ...tag, classes: tag_button, section: "tags" };
  });

  const fullArrayOfButtons = [...typesWithClass, ...tagsWithClass] || [];

  const showAllFilters = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsOpen(!isOpen);
  };

  const button = function (name, i, classes, section) {
    // Create classes based on button state
    const buttonClasses = classNames(classes, {
      [extended_buttons_open]: isOpen,
      [extended_buttons_closed]: !isOpen
    });

    const tagClasses = classNames(tag_button, {
      [tag_is_open]: isOpen,
      [tag_is_closed]: !isOpen
    });

    const brandClasses = classNames(brand_button, {
      [extended_buttons_open]: isOpen,
      [extended_buttons_closed]: !isOpen
    });

    const createButtonElement = (buttonText) => {
      return (
        <button
          onClick={(event) => {
            event.preventDefault();
            handleSelect(section, name.value || name.label || name);
          }}
          className={buttonClasses}
          key={`button-${i}`}
        >
          {buttonText}
        </button>
      );
    };

    // Render the first three buttons before the ellipsis
    if (i < 3) {
      return (
        <button
          onClick={(event) => {
            event.preventDefault();
            handleSelect(section, name.value || name.label || name);
          }}
          className={classes}
          key={i}
        >
          {convertToHumanReadable(name.label || name)}
        </button>
      );
    }

    // Render the ellipsis button and the next filter button
    if (i === 4) {
      return (
        <>
          <button
            onClick={(event) => {
              event.preventDefault();
              showAllFilters(event);
            }}
            className={tagClasses}
            key={i}
          >
            . . .
          </button>
          {createButtonElement(convertToHumanReadable(name.label || name))}
        </>
      );
    }

    // Render the rest of the buttons
    if (i >= 5) {
      const buttonText = convertToHumanReadable(name.label || name);

      // Check if this is also the last element in the array to render the minus button
      if (fullArrayOfButtons.length - 1 === i) {
        return (
          <>
            {createButtonElement(buttonText)}
            <button
              onClick={(event) => {
                event.preventDefault();
                showAllFilters(event);
              }}
              className={brandClasses}
              key={i}
            >
              &#8722;
            </button>
          </>
        );
      } else {
        return createButtonElement(buttonText);
      }
    }
  };

  return (
    <a className={container} href={`/knowledge-hub/${path}`}>
      <div className={image_container}>
        <img src={src} alt={title} />
      </div>
      <div className={text_container}>
        <div>
          <div className={header}>
            {topics.map((topic, i) => {
              return (
                <button
                  onClick={(event) => {
                    event.preventDefault();
                    navigate(`/knowledge-hub/topic/${topic.value || topic.label || topic}`);
                  }}
                  key={`buton-${i}`}
                >
                  {convertToHumanReadable(topic.label || topic)}
                </button>
              );
            })}
          </div>
          <h4>{title}</h4>
          {publishDate && <p>{formatDate(publishDate)}</p>}
          {/* Show location only on Truemont */}
          {location && process.env.ASTER_SITE_ID == 11 && (
            <div className={location_label}>
              <SVG name="map-marker" />
              <p>{location}</p>
            </div>
          )}
        </div>
        <div className={footer}>
          {fullArrayOfButtons.length > 0 &&
            fullArrayOfButtons.map((singularButton, i) => {
              return button(singularButton, i, singularButton.classes, singularButton.section);
            })}
        </div>
      </div>
    </a>
  );
};

Card.propTypes = {
  tags: PropTypes.array,
  handleSelect: PropTypes.func,
  types: PropTypes.array,
  keyProp: PropTypes.string,
  src: PropTypes.string,
  title: PropTypes.string,
  path: PropTypes.string,
  readTime: PropTypes.string,
  publishDate: PropTypes.string,
  location: PropTypes.string,
  topics: PropTypes.array
};

export default Card;
